<template>
  <button
    :class="{ compact: isCompact }"
    aria-label="Quickly and safely exit this website"
    class="button button--secondary button--lg justify-center quick-exit"
    @click="quickExit"
  >
    <div class="label">Quick Exit</div>
    <i class="icon icon--lg">
      <Icon name="fa6-solid:xmark" />
    </i>
  </button>
</template>

<script setup lang="ts">
const cookie = useCookie('compass-subscription-params', { path: '/' })
const props = defineProps<{
  isCompact?: boolean
  isGlobal?: boolean
}>()

onMounted(() => {
  if (props.isGlobal) {
    let elapsed, start
    document.addEventListener('keyup', (e) => {
      if (e.keyCode === 27) {
        elapsed = new Date().getTime()
        if (elapsed - start <= 350) {
          quickExit()
        }
        start = elapsed
      }
    })
  }
})

function quickExit() {
  cookie.value = null
  window.history.replaceState({}, '', '/')
  window.location.replace('https://google.com.au')
}
</script>

<style lang="less" scoped>
.button {
  width: 100%;

  @media @wide {
    padding-right: @gutter-lg; // aligns with desktop search
  }

  .icon {
    min-width: @14px;
    order: -1;
    padding: 0 !important;

    @media @wide {
      order: 1;
    }
  }

  .label {
    padding-left: @gutter-sm;

    @media @wide {
      padding: 0 @gutter 0 0;
    }
  }

  &.compact {
    .flex();
    .flex-col();

    width: @54px;
    height: @mobile-nav-height;
    padding: @6px;

    @media @tablet {
      width: @66px;
    }

    .label {
      .font-xs() !important;

      padding: 0;
      line-height: 1 !important;
    }

    .icon {
      .font-xl();

      order: -1;
      line-height: 1rem;
    }
  }
}
</style>
